export * from './full-layout.component';



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/containers/full-layout/index.ts